import { mapPayments } from "./paymentMapper";

export const mapCreditFiscalSale = (formData: any) => {
  return {
    saleId: formData.id ?? null, // ← si el backend lo requiere, de lo contrario elimínalo
    branch: formData.branch ?? null, // ← opcional, si lo ocupás en backend
    customer: formData.customer ?? null, // ← opcional, si lo ocupás en backend
    documentType: formData.documentType ?? null, // ← opcional
    saleDate: formData.saleDate,
    paymentCondition: formData.paymentCondition ?? null, // 👈 objeto con { id, name }
    // paymentMethod: formData.paymentMethod ?? null, // 👈 objeto con { id, name }
    // individualPayments: formData.individualPayments || {}, // 👈 estructura tipo IndividualPaymentsDTO
    payments: mapPayments(formData.payments),
    comments: formData.comments || null,
  };
};
